const { detect } = require('detect-browser');
const browser = detect();

import checkViewportChange from './modules/checkViewportChange.js';
import Menu from './modules/menu.js';

const [w, d] = [window, document];

const init = () => {
  const root = document.documentElement;
  root.classList.add(browser.name);

  checkViewportChange();

  const globalNav = new Menu(d.getElementsByClassName('c-menu')[0]);
};

document.addEventListener('DOMContentLoaded', e => {
  init();
});
